import GlobalInterfaceStyle from "../UI/GlobalInterfaceStyle";
import React, { createContext, useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { GlobalModalStyle, CloseModalButton } from './styles';

const PopUpContext = createContext();
const usePopUp = () => useContext(PopUpContext);

let modalId = 0;

function BootBox({ children }) {
  const [modais, setModais] = useState([]);

  const FechaBootBox = (id = null) => {
    setModais((prev) => {
      if (id !== null && typeof id === 'number' && id > 0) {
        return prev.filter((m) => m.id !== id);
      } else {
        const novos = [...prev];
        novos.pop();
        return novos;
      }
    });
  };

  const DisparaBootBox = (
    Title,
    Mensagem,
    Buttons,
    Value,
    handleConfirm,
    Size = 'lg',
    CloseBtn = true,
    withComponent = false,
    isTopButton = false
  ) => {
    const id = modalId++;

    const buttonsRender = Buttons || [
      {
        variant: 'primary',
        action: handleConfirm,
        label: '✓ Confirmar',
      },
      {
        variant: 'secondary',
        action: () => FechaBootBox(id),
        label: '✗ Cancelar',
      },
    ];

    const novoModal = {
      id,
      title: Title,
      mensagem: withComponent ? Mensagem : () => Mensagem,
      buttons: buttonsRender,
      value: Value,
      size: Size,
      closeButton: CloseBtn,
      topButton: isTopButton
    };

    setModais((prev) => [...prev, novoModal]);
  };

  return (
    <PopUpContext.Provider value={{ DisparaBootBox, FechaBootBox }}>
      {children}
      <GlobalModalStyle />
      <GlobalInterfaceStyle />

      {modais.map((modal) => (
        <Modal
          key={modal.id}
          show={true}
          onHide={() => FechaBootBox(modal.id)}
          size={modal.size}
          className={modal.size === 'xl' ? 'modal-xl' : ''}
        >
          <Modal.Header>
            <Modal.Title>{modal.title}</Modal.Title>
            {modal.closeButton && (
              <CloseModalButton
                type="button"
                aria-label="Fechar modal"
                title="Fechar"
                onClick={() => FechaBootBox(modal.id)}
              />
            )}            
          </Modal.Header>

          { modal.topButton && (
            <Modal.Footer>
              { modal.buttons.map((button, index) => (
                <Button
                  key={index}
                  variant={button.variant}
                  onClick={() => button.action(modal.value)}
                >
                  {button.label}
                </Button>
              ))}
            </Modal.Footer>
          )}

          <Modal.Body style={{overflowY: 'auto'}}>
            {typeof modal.mensagem === 'function'
              ? modal.mensagem()
              : modal.mensagem}
          </Modal.Body>

          { !modal.topButton && (
            <Modal.Footer>
              { modal.buttons.map((button, index) => (
                <Button
                  key={index}
                  variant={button.variant}
                  onClick={() => button.action(modal.value)}
                >
                  {button.label}
                </Button>
              ))}
            </Modal.Footer>
          )}
        </Modal>
      ))}
    </PopUpContext.Provider>
  );
}

export { BootBox, usePopUp };
